import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <strong>
        <a
          href="https://github.com/berryjen/react-dictionary"
          target="_blank"
          className="gitHub"
          rel="noopener noreferrer"
        >
          Open source {""}
        </a>
        code by {""}
        <a
          href="https://linkedin.com/in/jennifer-s-27462888"
          target="_blank"
          className="linkedIn"
          rel="noopener noreferrer"
        >
          Jennifer Su {""}
        </a>
      </strong>
    </div>
  );
}